import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// ERP Lot Code Interfaces
export interface ERPLotCodeRequest {
  OrganizationCode: string;
  ItemNumber: string;
}

export interface LotDto {
  LotNumber: string;
  PrimaryQuantity: number;
  MaterialStatus: string;
  ExpirationDate: string;
  SubinventoryCode?: string;
  Locator?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ShopFloorDataService {
  private ERPUrl = 'https://fa-epbd-test-saasfaprod1.fa.ocs.oraclecloud.com:443/fscmRestApi/resources/11.13.18.05/inventoryOnhandBalances';
  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }

  get o3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(private http: HttpClient) { }

  getGroupData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Common/GetGroup', data);
  }

  GetStatus(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Planner/GetStatus', data);
  }

  GetTreeModal(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Common/GetTreeModal', data);
  }

  GetProcessOrderList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetProcessOrderList', data);
  }

  GetLastShiftInfo(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetLastShiftInfo', data);
  }

  GetLatestLotCode(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetLatestLotCode', data);
  }

  GetJbDowntimeHistory(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetJbDowntimeHistory', data);
  }
  getOEEInfo(id: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'OEEConfig/GetOEEInfo', id);
  }
  GetKpiParamInfoList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetKpiParamInfoList', data);
  }

  GetLableBatch(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetLableBatch', data);
  }

  GetItemTypeByUnit(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetItemTypeByUnit', data);
  }

  GetTotalBatch(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetTotalBatch', data);
  }
  GetTotalBatchForSFDC(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetTotalBatchForSFDC', data);
  }

  GetJbBatchHistory(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetJbBatchHistory', data);
  }

  GetWasteFaultByUnit(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetWasteFaultByUnit', data);
  }

  GetFaultByUnit(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetFaultByUnit', data);
  }

  GetStDuration(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetStDuration', data);
  }

  SaveJBDowntimeInfo(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/SaveJBDowntimeInfo', data);
  }

  BulkUpdateDowntimeFaults(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/BulkUpdateDowntimeFaults', data);
  }

  SumbitProcessOrderStatus(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/SumbitProcessOrderStatus', data);
  }

  SaveJBBatchInfo(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/SaveJBBatchInfo', data);
  }

  getSapQuantityForMC(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetSapQuantityForMC', data);
  }

  getQuantityByLotCode(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetQuantityByLotCode', data);
  }

  SaveSapProductionOutput(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/SaveSapProductionOutput', data);
  }

  SaveSapMaterialConsumption(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/SaveSapMaterialConsumption', data);
  }

  GetJbWasteHistory(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetJbWasteHistory', data);
  }

  SaveJBWasteInfo(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/SaveJBWasteInfo', data);
  }

  GetSTFault(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetSTFault', data);
  }

  getMasterSlaveUnit(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetMasterSlaveUnit', data);
  }


  GetBatchCheckListByUnit(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetBatchCheckListByUnit', data);
  }

  // GetLatestLotCode(data: any): Observable<any[]> {
  //   const token = localStorage.getItem('token');
  //   const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
  //   return this.http.post<any[]>(this.baseUrl + 'SDFC/GetLatestLotCode', data);
  // }

  GetKpiParameters(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetKpiParameters', data);
  }

  GetKpiParamInfoDetails(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetKpiParamInfoDetails', data);
  }

  SumbitJobKpiParameters(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/SumbitJobKpiParameters', data);
  }

  GetTotalWaste(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetTotalWaste', data);
  }
  GetTotalWasteSFDC(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetTotalWasteSFDC', data);
  }
  GetJbBatchchecklistDetails(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetJbBatchchecklistDetails', data);
  }

  GetShiftCloseValidation(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetShiftCloseValidation', data);
  }

  GetIsShiftStart(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetIsShiftStart', data);
  }

  GetValidationInfo(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetValidationInfo', data);
  }

  SumbitShiftClose(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/SumbitShiftClose', data);
  }

  GetBarCodeDetails(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'BarcodePrint/GetBarCodeDetails', data);
  }
  GetBarCodeDetailsLocalOrExport(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'BarcodePrint/GetBarCodeDetailsLocalOrExport', data);
  }

  //================================ Food Sector ================================//

  getFoodSector(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetIsFoodSector', data);
  }
  getItemBomListInfo(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetItemBOMListInfo', data);
  }
  SaveFoodSectorMaterialConsumption(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/SubmitItemBOMBatchInfo', data);
  }
  getBatchItemBOMList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetBatchItemBOMList', data);
  }
  getBatchItemBOMInfo(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetBatchItemBOMInfo', data);
  }

  getBatchConsumptionDD(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetBatchConsumptionList', data);
  }
  //===================================== Production Start =============================//
  getProductionDetailList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'ProductionStart/GetDetails', data);
  }
  updateProductionDetail(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'ProductionStart/PostDetails', data);
  }

  GetProductionDowntime(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetProductionReportDowntime', data);
  }

  //================================ sfdc events ================================//
  //NOT IN USE
  // async addSfdcEvent(data: any): Promise<any> {
  //   return await this.http.post<any>(this.apiUrl + 'addsfdcevents', data).toPromise();
  // }
  async insertSfdcEvent(data: any): Promise<any> {
    return await this.http.post<any>(this.o3CoreApiUrl + 'Quality/InsertSFDCEvents', data).toPromise();
  }
  getComponentListByAssembly(data: any): Observable<any> {
    return this.http.post<any[]>(this.o3CoreApiUrl + 'CIL/GetComponentListByAssembly', data);
  }
  getComponentListByAssemblyDashboard(data: any): Observable<any> {
    return this.http.post<any[]>(this.o3CoreApiUrl + 'Dashboard/GetComponentListByAssembly', data);
  }
  GetSFDCChart(data: any): Observable<any> {
    return this.http.post<any>(this.o3CoreApiUrl + 'Quality/GetSFDCChart', data);

  }
  GetMaintanceInfo(data: any): Observable<any> {
    return this.http.post<any>(this.o3CoreApiUrl + 'SDFC/GetMaintanceInfo', data);
  }

  GetJbBatchHistoryHoney(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetJbBatchHistoryHoney', data);
  }

  GetTanksByMachine(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetTanksByMachine', data);
  }

  GetAlternativeItems(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetAlternativeItems', data);
  }

  GetStorageTankEntries(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetStorageTankEntries', data);
  }

  getErpDataByMachine(data: any): Observable<any> {
    return this.http.post<any>(this.o3CoreApiUrl + 'SDFC/GetErpDataByMachine', data);
  }

  //=======================================NO PO======================================
  GetProductionInfo(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetProductionInfo', data);
  }
  StartProductionbyProduct(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/StartProductionbyProduct', data);
  }

  //======================================== Performance loss ================================

  GetPerformanceAlertDurationByUnit(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetPerformanceAlertDurationByUnit', data);
  }
  GetPerformanceFaultByUnit(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetPerformanceFaultByUnit', data);
  }

  GetPoDetailsbyduration(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetPoDetailsbyduration', data);
  }

  savePerformanceLosss(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/savePerformanceLosss', data);
  }

  GetPerformanceFaultDetails(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetPerformanceFaultDetails', data);
  }

  GetSOPListWithAttachmentListByValue(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/GetSOPAttachmentListByValue', data);
  }

  getOperationDetailsByUnit(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'ProductionOrder/getOperationDetailsByUnit', data);
  }

  getOperationDetailsByUnitAndStatus(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'ProductionOrder/GetOperationDetailsByUnitAndStatus', data);
  }

  updateNoPoProduct(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'ProductionOrder/NoPOProductUpdate', data);
  }

  updateNoPo(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'ProductionOrder/NoPOUpdate', data);
  }

  getLotCodeFromERP(data: ERPLotCodeRequest): Observable<LotDto[]> {
    return this.http.post<LotDto[]>( this.baseUrl + 'SDFC/GetLotCodeFromERP', data );
  }
}
